import { mainClient } from 'boot/axios'
import { ILoginData, IMeta, IPortalUser } from 'src/common/interfaces/index.js'

const ILoginResponse = {
  meta: IMeta,
  data: { invitation_data: { token: '', portal_user: IPortalUser, login_data: ILoginData } },
}
const IGetInvitedUserResponse = {
  meta: IMeta,
  data: { invitation_data: { partner_id: 0, first_name: '', surname: '', business_name: '', email: '', license: '' } },
}

export const partner = {
  /**
   * @param {{token: string}} payload
   * @return {Promise<ILoginResponse>}
   */
  loginData(filter = {}, signal) {
    return mainClient.post('partners/businesses/login/data', { filter }, { signal })
  },

  /**
   * @param {{token: string}} payload
   * @return {Promise<IGetInvitedUserResponse>}
   */
  getInvitedUserData(filter = {}, signal) {
    return mainClient.post('partners/businesses/invite/data', { filter }, { signal })
  },
}
